import {usePaymentCheckoutContent} from '@/content/paymentCheckout'
import {useRegistrationFormContent} from '@/content/registrationForm'
import {QueryLink, TrademarkTypeValue} from '@/utils/constants'
import {CoreRegistrationFieldsFragment} from '@/utils/graphqlSdk'

export const isWordTrademark = (type: TrademarkTypeValue): boolean =>
  [TrademarkTypeValue.text, TrademarkTypeValue.combined].includes(type)

export const isLogoTrademark = (type: TrademarkTypeValue): boolean =>
  [TrademarkTypeValue.image, TrademarkTypeValue.combined].includes(type)

export const getTrademarkName = (request: CoreRegistrationFieldsFragment): string =>
  request?.type === TrademarkTypeValue.image
    ? request?.verification_results[0]?.transcription ?? ''
    : request?.value

export const useFormConsentNote = (
  isUs: boolean,
  isRegistrationRequest = false,
  hasBrandProtection = false,
) => {
  const {consentNote} = usePaymentCheckoutContent()
  const {consentNote: monitoringNote} = useRegistrationFormContent().monitoringUpsell

  if (isRegistrationRequest && hasBrandProtection) {
    return isUs ? monitoringNote.us : monitoringNote.general
  } else return isUs ? consentNote.us : consentNote.general
}

export const getFormReassuranceDescriptionKey = (
  query: QueryLink['query'],
  prefillParamKeys: string[],
  prefillSourceValue: string,
  descriptions: {default: string; prefilled: string; pricelist: string},
): string => {
  const hasPrefillParams = prefillParamKeys.some((key) => Boolean(query?.[key]))
  const isFromPricing = hasPrefillParams && query?.prefillSource === prefillSourceValue

  if (isFromPricing) {
    return descriptions.pricelist
  }
  if (hasPrefillParams) {
    return descriptions.prefilled
  }
  return descriptions.default
}
